import { render, staticRenderFns } from "./TeamTemplateModal.vue?vue&type=template&id=3acd18dd&scoped=true&"
import script from "./TeamTemplateModal.vue?vue&type=script&lang=js&"
export * from "./TeamTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd18dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3acd18dd')) {
      api.createRecord('3acd18dd', component.options)
    } else {
      api.reload('3acd18dd', component.options)
    }
    module.hot.accept("./TeamTemplateModal.vue?vue&type=template&id=3acd18dd&scoped=true&", function () {
      api.rerender('3acd18dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/TeamTemplateModal.vue"
export default component.exports